module.exports = "data:text/x-markdown;base64,TWFpbkNoZWYgaXMgYWdhaW5zdCBzbGF2ZXJ5IQ0KTW92ZSBmcm9tIGBNYXN0ZXJDaGVmYCB0byBgTWFpbkNoZWZgIGFuZCBtb3ZlIGZyb20gYFNVU0hJYHMgdG8gYEtISU5LQUxgcyENCg0KUGxlYXNlIGNoZWNrIGlmIHlvdSBjYW4gZHJhaW4gdGhlIGZ1bmRzIGZyb20gb3VyIG1haW4gY29udHJhY3QuDQoNCllvdSBoYXZlIHRvIGRyYWluIGFsbCB0aGUgS0hJTktBTCB0b2tlbnMgZnJvbSB0aGUgTWFpbkNoZWYncyBiYWxhbmNlLg0K"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/mainchef.md
// module id = 1835
// module chunks = 0